import * as React from 'react';
import * as styles from './HubBlock.css';
import { Body2, UIHeading4 } from '@cian/ui-kit';
import { IComparisonAlbumImage, TPropertyType } from '../../types/redux/comparisonAlbums';
import { TCompareHubCategory } from '../../containers/CompareHubPage/tracking';
import { HubImage } from './HubImage';

interface IHubBlockProps {
  type: TPropertyType;
  images: IComparisonAlbumImage[];
  onClick(label: TCompareHubCategory): void;
  title: string;
  subtitle: string;
}

export const HubBlock: React.FC<IHubBlockProps> = ({ type, title, subtitle, images, onClick }) => {
  const dataTestId = `hub-link-${type}`;
  const url = `/compare/?activeTab=${type === 'offer' ? 'offers' : 'newbuildings'}`;

  const clickHandler = React.useCallback(() => {
    onClick(type === 'offer' ? 'Compare' : 'CompareJK');
  }, [type, onClick]);

  const preparedImages: string[] = React.useMemo(() => {
    return images.slice(0, 3).map(image => image.url);
  }, [images]);

  return (
    <div className={styles['container']} data-testid={dataTestId} onClick={clickHandler}>
      <a href={url} className={styles['link-area']}></a>
      <div className={styles['images']}>
        <div className={styles['image-wrapper']}>
          <HubImage url={preparedImages[0]} />
        </div>
        <div className={styles['image-wrapper']}>
          <HubImage url={preparedImages[1]} />
        </div>
        <div className={styles['image-wrapper']}>
          <HubImage url={preparedImages[2]} />
        </div>
      </div>
      <UIHeading4>{title}</UIHeading4>
      <Body2 color="text-secondary-default">{subtitle}</Body2>
    </div>
  );
};
